<template>
  <article class="product-detail-popup" :data-id="id">
    <section class="product-detail iscroll" id="product-detail">
      <div class="product-detail-track">
        <section class="product-detail-block product-detail-block--header">
          <div class="product-detail-header">
            <page-toolbar
              :editMenuItems="[
                {
                  text: 'Images',
                  url: '#'
                },
                {
                  text: 'Title',
                  url: '#'
                },
                {
                  text: 'Price',
                  url: '#'
                },
                {
                  text: 'Sale Price',
                  url: '#'
                },
                {
                  text: 'Variants',
                  url: '#'
                },
                {
                  text: 'Collections',
                  url: '#'
                },
                {
                  text: 'Description',
                  url: '#'
                }
              ]"
              :moreMenuItems="[
                [
                  {
                    text: 'Share Product',
                    share: shareData
                  },
                  {
                    target: '_parent',
                    text: 'Edit Product in Shopify',
                    url: platformAdminUrl
                  },
                  {
                    target: '_blank',
                    text: 'View Live Product',
                    url: platformUrl
                  }
                ],
                $moreLinks
              ]"
              :shareButtonData="shareData"
              :showBackButton="true"
              v-on:back-button-click="handleToolbarBackButtonClick"
            />
          </div>
        </section>

        <section class="product-detail-block product-detail-block--main">
          <div class="product-detail-columns">
            <div class="product-detail-column product-detail-column--image">
              <template v-if="product">
                <div class="product-detail-image">
                  <div v-if="isUnpublished" class="product-detail-image__badge">
                    <ProductTileBadge text="Unavailable" />
                  </div>
                  <div class="product-detail__image"
                    v-if="product.image"
                    :style="{ backgroundImage: `url(${ product.image.url })` }"
                  ></div>
                  <div class="product-detail__image product-detail__image--placeholder" v-else></div>
                </div>

                <div v-if="product.title" :class="`product-detail-info${product.compare_at_price ? ' product-detail-info--has-sale-price' : ''}`">
                  <div class="product-detail-info__item product-detail-info__item--inline">
                    <h5 class="product-detail-info__label">Visitors Right Now</h5>
                    <p class="product-detail-info__value">{{ activeUsers }}</p>
                  </div>

                  <div v-if="product.price" class="product-detail-info__item product-detail-info__item--inline product-detail-info__price">
                    <h5 class="product-detail-info__label">Price</h5>
                    <p class="product-detail-info__value">{{ product.price | currency }}</p>
                  </div>

                  <div v-if="product.compare_at_price" class="product-detail-info__item product-detail-info__item--inline product-detail-info__compare-at-price">
                    <h5 class="product-detail-info__label">Compare At Price</h5>
                    <p class="product-detail-info__value">{{ product.compare_at_price | currency }}</p>
                  </div>

                  <div v-if="product.variants && product.variants.length > 0" class="product-detail-info__item product-detail-info__item--inline">
                    <h5 class="product-detail-info__label">Current Stock</h5>
                    <p class="product-detail-info__value">{{ product.inventory }}</p>
                  </div>

                  <div v-if="product.variants && product.variants.length > 0" class="product-detail-info__item product-detail-info__item--inline">
                    <h5 class="product-detail-info__label">Variants</h5>
                    <p class="product-detail-info__value">{{ product.variants.length }} Total</p>
                  </div>

                  <div v-if="product.collections && product.collections.length > 0" class="product-detail-info__item">
                    <drawer>
                      <template slot="control">
                        <h5 class="product-detail-info__label">
                          <span>Found In</span>
                          <span class="product-detail-info__parenthesis">({{ numCollectionsMsg(product.collections.length) }})</span>
                        </h5>
                      </template>

                      <template slot="content">
                        <p class="product-detail-info__value">
                          <div class="product-detail-info__collections">
                            <!-- <span v-for="(collection, index) in product.collections" class="product-detail-info__collection" :key="index">{{ collection.title }}</span> -->
                            <router-link v-for="(collection, index) in product.collections" :key="index" :to="{name: 'Product Collection', params: {id: collection.id}, title: collection.title}" class="product-detail-info__collection">{{ collection.title }}</router-link>
                          </div>
                        </p>
                        <button class="product-detail-info__more-button" type="button">{{ String.fromCharCode(59654) }}</button>
                      </template>
                    </drawer>
                  </div>

                  <div v-if="product.description" class="product-detail-info__item">
                    <drawer>
                      <template slot="control">
                        <h5 class="product-detail-info__label">Product Description</h5>
                      </template>

                      <template slot="content">
                        <p class="product-detail-info__value">
                          {{ product.description }}
                        </p>
                        <!-- <button class="product-detail-info__more-button" type="button">More</button>
                        <button class="product-detail-info__more-button" type="button" :style="{ display: 'none' }">{{ String.fromCharCode(59654) }}</button> -->
                      </template>
                    </drawer>
                  </div>
                </div>
              </template>
            </div>

            <div class="product-detail-column product-detail-column--info">
              <section data-tabs class="__product-detail-block __product-detail-block--tabs" v-if="stats">
                <template v-if="product">
                  <div class="product-detail__lockup">
                    <div class="product-detail__image"
                      v-if="product.image"
                      :style="{ backgroundImage: `url(${ product.image.url })` }"
                    ></div>
                    <div class="product-detail__lockup-text">
                      <h5 class="product-detail__vendor"
                        v-if="hasMultipleVendors && product.vendor"
                      >{{ product.vendor }}</h5>
                      <h2 class="product-detail__title"
                        v-if="product.title"
                      >{{ product.title }}</h2>
                    </div>
                  </div>
                <section>
                  <product-filters
                    :dateRangeFilterChangeHandler="this.$parent.dateFilter"
                    :dateRangeFilterRange="this.$parent.filterDateRange"
                    :dateRangeFilterSelectedRange="this.$parent.selectedDateRange"
                    :filtersActive="filtersActive"
                    :isDashboardVisible="isDashboardVisible"
                    :isFiltersVisible="isFiltersVisible"
                    :possibleFilters="product.options"
                    @scrollToggle="scrollToggle"
                    @toggleDashboard="toggleDashboard"
                    @toggleFilters="toggleFilters"
                    isOnProductDetailPage
                  />

                  <section :class="`tags`">
                    <ActiveFiltersList
                      :activeFilters="filtersActive"
                      isOnProductDetailPage
                    />
                  </section>
                </section>
                </template>

                <template v-if="stats">
                  <menu class="tab-nav">
                    <ol class="tab-nav__list">
                      <li class="tab-nav__item"
                        :data-nav-tab="slugify(stat.title)"
                        v-for="stat in stats"
                        :key="stat.title"
                        @click.prevent="activeTab(slugify(stat.title)); tabs($event, '.product-detail')"
                      >
                        <a class="tab-nav__link"
                          :href="url = '?view=' + slugify(stat.title)"
                          @click.prevent
                        >{{ stat.title == 'Overview' ? 'Sales'
                          : stat.title === 'Sales'
                          ? 'Orders & Customers'
                          : stat.title }}
                        </a>
                      </li>
                    </ol>
                  </menu>
                </template>

                <template v-if="stats">
                  <ol class="tab-content">
                    <template v-for="stat in stats">
                      <li class="tab-content-nav"
                        :key="'tab-content-nav-' + stat.title"
                        :data-content-nav-tab="slugify(stat.title)"
                        @click.prevent="activeTab(slugify(stat.title)); tabs($event, '.product-detail')"
                      >
                        <a class="tab-content-nav__link"
                          :href="url = '?view=' + slugify(stat.title)"
                          @click.prevent
                        >{{ stat.title }}</a>
                      </li>
                      <li class="tab-content__item"
                        :key="'tab-content-' + stat.title"
                        :class="{ 'active': slugify(stat.title) === tabActiveId }"
                        :data-tab="slugify(stat.title)"
                      >
                        <product-detail-stats
                          :id="id"
                          :productId="id"
                          :tabActiveId="tabActiveId"
                          :tabId="slugify(stat.title)"
                          :title="stat.title"
                          :sales="sales"
                        ></product-detail-stats>
                      </li>
                    </template>
                  </ol>
                </template>
              </section>
            </div>
          </div>
        </section>

        <section class="product-detail-block product-detail-block--variants">
          <product-detail-variants
            :productId="id"
            :tabActiveId="tabActiveId"
          />
        </section>
        <section class="product-detail-block product-detail-block--info-mobile">
          <div class="product-detail-column product-detail-column--image">
            <template v-if="product">
              <h1 class="product-detail__info-title">Product Info.</h1>
              <div class="product-detail-image">
                <div v-if="isUnpublished" class="product-detail-image__badge">
                  <ProductTileBadge text="Unavailable" />
                </div>
                <div class="product-detail__lockup" v-if="product.image">
                  <div class="product-detail__image"
                    :style="{ backgroundImage: `url(${ product.image.url })` }"
                  ></div>
                  <div class="product-detail__lockup-text">
                    <h5 class="product-detail__vendor"
                      v-if="hasMultipleVendors && product.vendor"
                    >{{ product.vendor }}</h5>
                    <h2 class="product-detail__title"
                      v-if="product.title"
                    >{{ product.title }}</h2>
                  </div>
                </div>
                <div class="product-detail__image product-detail__image--placeholder" v-else></div>
              </div>

              <div v-if="product.title" :class="`product-detail-info${product.compare_at_price ? ' product-detail-info--has-sale-price' : ''}`">
                <div class="product-detail-info__item product-detail-info__item--inline">
                  <h5 class="product-detail-info__label">Visitors Right Now</h5>
                  <p class="product-detail-info__value">{{ activeUsers }}</p>
                </div>

                <div v-if="product.price" class="product-detail-info__item product-detail-info__item--inline product-detail-info__price">
                  <h5 class="product-detail-info__label">Price</h5>
                  <p class="product-detail-info__value">{{ product.price | currency }}</p>
                </div>

                <div v-if="product.compare_at_price" class="product-detail-info__item product-detail-info__item--inline product-detail-info__compare-at-price">
                  <h5 class="product-detail-info__label">Compare At Price</h5>
                  <p class="product-detail-info__value">{{ product.compare_at_price | currency }}</p>
                </div>

                <div v-if="product.variants && product.variants.length > 0" class="product-detail-info__item product-detail-info__item--inline">
                  <h5 class="product-detail-info__label">Current Stock</h5>
                  <p class="product-detail-info__value">{{ product.inventory }}</p>
                </div>

                <div v-if="product.variants && product.variants.length > 0" class="product-detail-info__item product-detail-info__item--inline">
                  <h5 class="product-detail-info__label">Variants</h5>
                  <p class="product-detail-info__value">{{ product.variants.length }} Total</p>
                </div>

                <div v-if="product.collections && product.collections.length > 0" class="product-detail-info__item">
                  <drawer>
                    <template slot="control">
                      <h5 class="product-detail-info__label">
                        <span>Found In</span>
                        <span class="product-detail-info__parenthesis">({{ numCollectionsMsg(product.collections.length) }})</span>
                      </h5>
                    </template>

                    <template slot="content">
                      <p class="product-detail-info__value">
                        <div class="product-detail-info__collections">
                          <span v-for="(collection, index) in product.collections" :key="index" class="product-detail-info__collection">{{ collection.title }}</span>
                        </div>
                      </p>
                      <button class="product-detail-info__more-button" type="button">{{ String.fromCharCode(59654) }}</button>
                    </template>
                  </drawer>
                </div>

                <div v-if="product.description" class="product-detail-info__item">
                  <drawer>
                    <template slot="control">
                      <h5 class="product-detail-info__label">Product Description</h5>
                    </template>

                    <template slot="content">
                      <p class="product-detail-info__value">
                        {{ product.description }}
                      </p>
                      <!-- <button class="product-detail-info__more-button" type="button">More</button>
                      <button class="product-detail-info__more-button" type="button" :style="{ display: 'none' }">{{ String.fromCharCode(59654) }}</button> -->
                    </template>
                  </drawer>
                </div>
              </div>
            </template>
          </div>
        </section>

        <template v-if="!product">
          <section class="product-detail-block product-detail-block--loading">
            <div class="product-detail-columns">
              <div class="product-detail-column product-detail-column--image">
                <div class="product-detail-image">
                  <div class="product-detail__image product-detail__image--placeholder"></div>
                </div>
              </div>

              <div class="product-detail-column product-detail-column--info">
                <p class="product-detail__subtitle">
                  <span class="placehold placehold--height-15 placehold--margin-bottom-15 placehold--width-100"></span>
                </p>

                <h2 class="product-detail__title">
                  <span class="placehold placehold--height-23 placehold--margin-bottom-18 placehold--width-200"></span>
                </h2>

                <p class="product-detail__info">
                  <span class="placehold placehold--height-15 placehold--margin-bottom-9 placehold--width-100-percent"></span>
                  <span class="placehold placehold--height-15 placehold--margin-bottom-9 placehold--width-100-percent"></span>
                  <span class="placehold placehold--height-15 placehold--margin-bottom-8 placehold--width-60-percent"></span>
                </p>

                <div class="product-detail-lists">
                  <ul class="product-detail-lists__list">
                    <li class="product-detail-lists__item product-detail-lists__item--title">
                      <span class="placehold placehold--height-15 placehold--margin-bottom-5 placehold--width-50"></span>
                    </li>
                    <li class="product-detail-lists__item">
                      <span class="placehold placehold--height-15 placehold--margin-bottom-5 placehold--width-50"></span>
                    </li>
                  </ul>

                  <ul class="product-detail-lists__list">
                    <li class="product-detail-lists__item product-detail-lists__item--title">
                      <span class="placehold placehold--height-15 placehold--margin-bottom-5 placehold--width-50"></span>
                    </li>
                    <li class="product-detail-lists__item">
                      <span class="placehold placehold--height-15 placehold--margin-bottom-5 placehold--width-150"></span>
                    </li>
                  </ul>

                  <ul class="product-detail-lists__list">
                    <li class="product-detail-lists__item product-detail-lists__item--title">
                      <span class="placehold placehold--height-15 placehold--width-50"></span>
                    </li>
                    <li class="product-detail-lists__item">
                      <span class="placehold placehold--height-15 placehold--width-100"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </template>
      </div>
    </section>
  </article>
</template>

<script>
  import _flattenDeep from 'lodash/flattenDeep'
  import _find from 'lodash/find'
  import _filter from 'lodash/filter'
  import _intersection from 'lodash/intersection'
  import _map from 'lodash/map'
  import _sumBy from 'lodash/sumBy'
  import _uniq from 'lodash/uniq'
  import axios from 'axios'
  import IScroll from 'iscroll/build/iscroll-probe'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'
  import { mapMutations, mapState } from 'vuex'

  import ActiveFiltersList from '@/components/ActiveFiltersList'
  import DateRangeFilter from '@/components/DateRangeFilter'
  import Drawer from '@/components/Drawer/Drawer'
  import LineClamp from '@/components/LineClamp'
  import PageToolbar from '@/components/PageToolbar'
  import ProductDatePicker from '@/components/ProductDatePicker'
  import ProductDetailStats from '@/components/ProductDetailStats'
  import ProductDetailVariants from '@/components/ProductDetailVariants'
  import ProductFilters from '@/components/ProductFilters'
  import ProductTileBadge from '@/components/ProductTileBadge'
  import { helpers } from '@/mixins/helpers.js'

  import { getProductFilters } from '@/utils/altview/getProductFilters.js'

  const moment = extendMoment(Moment)

  export default {
    name: 'productDetail',
    components: {
      ActiveFiltersList,
      'date-range-filter': DateRangeFilter,
      'drawer': Drawer,
      'line-clamp': LineClamp,
      'page-toolbar': PageToolbar,
      'product-date-picker': ProductDatePicker,
      'product-detail-stats': ProductDetailStats,
      'product-detail-variants': ProductDetailVariants,
      'product-filters': ProductFilters,
      ProductTileBadge
    },
    mixins: [ helpers ],
    props: {
      id: {
        default: '',
        type: [String]
      }
    },
    data () {
      return {
        activeUsers: 0,
        checkoutCart: null,
        checkoutCartAll: null,
        customerTopResults: null,
        customerTopResultsAll: null,
        dashboards: null,
        dashboardsAll: null,
        interval: '',
        iscroll: [],
        possibleFilters: [],
        previousDateRange: null,
        product: null,
        productDescriptionHeight: null,
        sales: null,
        salesAffinity: null,
        salesForecastHistory: null,
        salesHistory: null,
        salesHistoryPrevious: null,
        salesInventory: null,
        stats: [
          { title: 'Overview' },
          { title: 'Sales' },
          { title: 'Checkout' },
          { title: 'Traffic' }
          // { title: 'Forecast' }
        ],
        tabActiveId: '',
        trafficBrowser: null,
        trafficDevices: null,
        trafficLocation: null,
        trafficMap: null,
        trafficSources: null,
        trafficVisitors: null,
        trafficVisitorsAll: null,
        variantIds: [],
        variantTopResults: null,
        isFiltersVisible: false,
        isDashboardVisible: true,
        isProductsPage: false
      }
    },
    computed: {
      ...mapState(
        'ui',
        {
          filtersActive: 'filtersActiveProductDetailPage'
        }
      ),
      ...mapState(
        'mockData',
        {
          // filtersActive: 'filtersActiveProductDetailPage'
        }
      ),
      ...mapState(
        'shop',
        [
          'hasMultipleVendors'
        ]
      ),
      isUnpublished: function () {
        return this.product.published === null
      },
      platformAdminUrl: function () {
        let link = 'javascript:void(0);'

        if (this.product) {
          link = this.product._links.platform_admin_url.href
        }

        return link
      },
      platformUrl: function () {
        let link = 'javascript:void(0);'

        if (this.product) {
          link = this.product._links.platform_url.href
        }

        return link
      },
      shareData: function () {
        let shareData = null

        if (this.product) {
          const {
            image,
            title,
            vendor
          } = this.product

          shareData = {
            pageHeadline: title,
            pageSubline: vendor,
            productId: this.id,
            linkUrl: `https://app.helloseemore.com/product/${this.id}`,
            thumbnailUrl: image ? image.url : null
          }
        }

        return shareData
      }
    },
    watch: {
      filtersActive: function () {
        // when the active filters change, do this
        this.loadVariantIds()
        this.loadData()
      },
      id: function () {
        if (this.id) {
          this.init()
        } else {
          this.removeProduct()
        }
      },
      product: function () {
        if (this.id !== '') {
          this.initTab()
        }
      },
      '$parent.filterDateRange': function () {
        this.updatePreviousDateRange()
        this.dateFilter(this.$parent.filterDateRange)
      },
      '$route': function (to, from) {
        const fromName = from.name
        const toName = to.name

        // if we just change productId
        // toggle PDP modal takeover back on
        // so the window doesn't hide
        if (this.id !== '' && fromName === toName) {
          this.toggleClass('product-detail-active', 'product-detail-transition', 500)
        }
      }
    },
    created: function () {
      this.updatePreviousDateRange()
      if (this.id !== '') {
        this.init()
      }
    },
    methods: {
      ...mapMutations(
        'ui',
        {
          filterDeleteAll: 'filtersActiveProductDetailPageAssign'
        }
      ),
      ...mapMutations(
        'shop',
        [
          'hasMultipleVendorsAssign'
        ]
      ),
      activeTab (id) {
        this.tabActiveId = id
        this.loadVariantIds()
        this.loadData()
      },
      toggleFilters (isVisible) {
        this.isFiltersVisible = !this.isFiltersVisible
      },
      scrollToggle (isVisible) {
        if (isVisible === false) {
          this.isFiltersVisible = false
        } else {
          this.isFiltersVisible = true
        }
      },
      toggleDashboard () {
        this.isDashboardVisible = !this.isDashboardVisible
      },
      applyParams (params, includeDates = false, includeProductId = true) {
        // Date Filtering
        if (includeDates === true) {
          if (this.$parent.filterDateRange.end) {
            params['end'] = encodeURI(this.$parent.filterDateRange.end.format())
          }
          if (this.$parent.filterDateRange.start) {
            params['start'] = encodeURI(this.$parent.filterDateRange.start.format())
          }
        }

        if (includeProductId === true) {
          // Product filter filtering

          if (this.variantIds.length > 0) {
            params['variant_ids'] = this.variantIds.join()
          }

          // Product id
          params['product_id'] = this.id
        }

        return params
      },
      dateFilter (dateRange) {
        this.$parent.filterDateRange = dateRange
        this.$emit('productDetailDateChange', dateRange)
        this.loadData()
      },
      handleToolbarBackButtonClick () {
        this.$emit('reset')
        this.filterDeleteAll([])
        this.isFiltersVisible = false
      },
      handleProductDescriptionHeightChange (height) {
        // this.setState('productDescriptionHeight', (height + 8))
      },
      iScroll () {
        if (this.$ios) {
          let container = document.querySelector('.product-detail-popup')
          let elements = container.querySelectorAll('.iscroll')
          let iscroll = this.iscroll
          setTimeout(() => {
            for (let element of elements) {
              let id = element.id

              if (iscroll.indexOf(id) === -1) {
                iscroll.push(id)
                iscroll[id] = new IScroll('#' + id, {
                  mouseWheel: true,
                  probeType: 3
                })
              }
              iscroll[id].refresh()
            }
          }, 500)
          // Resize
          window.addEventListener('resize', () => {
            for (let id of iscroll) {
              iscroll[id].refresh()
            }
          })
        }
      },
      iScrollDestroy () {
        if (this.$ios) {
          let iscroll = this.iscroll
          for (let id of iscroll) {
            iscroll[id].destroy()
          }
          this.iscroll = []
        }
      },
      iScrollUpdate () {
        if (this.$ios) {
          setTimeout(() => { this.triggerWindowResize() }, 500)
        }
      },
      init () {
        // document.querySelector('[data-nav-tab="overview"]').click()

        this.toggleClass('product-detail-active', 'product-detail-transition', 500)
        this.variant_ids = []
        getProductFilters({ filter_type: 'vendor' }, (productFilters) => {
          const hasMultipleVendors = productFilters.length > 1

          if (hasMultipleVendors) {
            this.hasMultipleVendorsAssign(true)
          } else {
            this.hasMultipleVendorsAssign(false)
          }
        })
        this.loadProduct()
        this.loadActiveUsers()
        this.interval = setInterval(() => { this.loadActiveUsers() }, 15000)
        setTimeout(() => {
          this.iScroll() // IOS
          document.querySelector('[data-nav-tab="overview"]').click()
        }, 100)

        // Emit reset when ESC is pressed
        document.onkeydown = (evt) => {
          evt = evt || window.event
          if (evt.keyCode === 27) {
            this.$emit('reset')
          }
        }
      },
      initTab () {
        let active = this.slugify(this.stats[0].title) // Setup for share querystrings down the line
        // let contentNavTab = document.querySelector(`[data-content-nav-tab="${active}"]`)
        let navTab = document.querySelector(`[data-nav-tab="${active}"]`)

        if (this.getBreakpoint() < 1024) {
          // Will need this for querystrings down the line
          // contentNavTab.click()
        } else {
          navTab.click()
        }
      },
      loadActiveUsers () {
        let that = this

        return axios({
          method: 'get',
          url: `integration/google/analytics/${that.$domain}/realtime`
        })
        .then((response) => {
          let dimensions = _find(response.data, {'field': 'dimensions'})
          let dimension = _find(dimensions.values, {'field': 'active_pages'})

          that.activeUsers = 0

          if (dimension) {
            that.activeUsers = _sumBy(dimension.values, (obj) => {
              if (obj.label.includes(`products/${that.product.handle}`)) {
                return _find(obj.values, {'field': 'active_users'}).value
              } else {
                return 0
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadCarts (includeProductId = true) {
        let that = this
        let params = that.applyParams({}, true, includeProductId)

        return axios({
          method: 'get',
          url: `${that.$domain}/carts`,
          params: params
        })
      },
      loadCartsAll () {
        let that = this

        that.checkoutCart = null
        that.checkoutCartAll = null

        return axios.all([
          this.loadCarts(true),
          this.loadCarts(false),
          this.loadDashboards()
        ])
        .then(axios.spread((carts, cartsAll) => {
          that.checkoutCart = carts.data
          that.checkoutCartAll = cartsAll.data
          this.iScrollUpdate()
        }))
        .catch((error) => {
          console.log(error)
        })
      },
      loadCustomerTopResults (includeProductId = true) {
        let that = this
        let params = that.applyParams({
          group_by: 'customer_id',
          limit: 0
        }, true, includeProductId)

        return axios({
          method: 'get',
          url: `${that.$domain}/top_results`,
          params: params
        })
      },
      loadCustomerTopResultsAll () {
        let that = this

        that.customerTopResults = null
        that.customerTopResultsAll = null

        axios.all([
          this.loadCustomerTopResults(true),
          this.loadCustomerTopResults(false)
        ])
        .then(axios.spread((topResults, topResultsAll) => {
          that.customerTopResults = topResults.data.top_results
          that.customerTopResultsAll = topResultsAll.data.top_results
          this.iScrollUpdate()
        }))
        .catch((error) => {
          console.log(error)
        })
      },
      loadDashboards () {
        let that = this
        let params = that.applyParams({}, true)

        that.dashboards = null

        return axios({
          method: 'get',
          url: `${that.$domain}/order_sales_dashboard`,
          params: params
        })
        .then((response) => {
          that.dashboards = response.data.dashboards
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadDashboardsAll () {
        let that = this
        let params = that.applyParams({}, true, false)

        that.dashboardsAll = null

        return axios({
          method: 'get',
          url: `${that.$domain}/order_sales_dashboard`,
          params: params
        })
        .then((response) => {
          that.dashboardsAll = response.data.dashboards
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadData () {
        let methodMap = {
          checkout: 'loadCartsAll',
          forecast: 'loadSalesForecastHistory',
          overview: 'loadOverviewMethods',
          sales: 'loadSalesMethods',
          traffic: 'loadTrafficVisitorsAll'
        }

        this.iScrollUpdate()
        this.$Progress.start()

        // Map the active tab to data method
        if (Object.keys(methodMap).includes(this.tabActiveId)) {
          let method = methodMap[this.tabActiveId]
          this[method]().then(() => {
            this.$Progress.finish()
          }).catch(() => {
            this.$Progress.fail()
          })
        }
      },
      loadOverviewMethods () {
        return axios.all([
          this.loadSales(),
          this.loadDashboards(),
          this.loadSalesHistory()
        ])
        .then(() => {
          this.loadDashboardsAll()
          this.loadSalesHistoryAll()
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadProduct () {
        return axios({
          method: 'get',
          url: `${this.$domain}/products/${this.id}`
        })
        .then((response) => {
          let result = response.data
          this.product = result

          const variantsFilterLists = _flattenDeep(_map(this.product.variants, 'filter_list'))

          let variants = _filter(variantsFilterLists, (variantId) => {
            return variantId.toLowerCase().indexOf('option') !== -1
          })

          variants = _uniq(variants)

          this.possibleFilters = variants

          this.$emit('pdpProduct', result)
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadSales () {
        let that = this
        let params = that.applyParams({
          group_by: 'variant_id'
        }, true)

        that.sales = null

        return axios({
          method: 'get',
          url: `${that.$domain}/item_sales`,
          params: params
        })
        .then((response) => {
          that.sales = response.data
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadSalesAffinity () {
        let that = this
        let params = that.applyParams({}, true)

        that.salesAffinity = null

        return axios({
          method: 'get',
          url: `${that.$domain}/item_sales/affinity`,
          params: params
        })
        .then((response) => {
          that.salesAffinity = response.data.products
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadSalesHistory (attribute = 'salesHistory', dateRange = null, groupBy = 'day') {
        let that = this
        let params = that.applyParams({
          group_by: groupBy
        }, true)

        if (dateRange) {
          params['start'] = encodeURI(dateRange.start.format())
          params['end'] = encodeURI(dateRange.end.format())
        }

        return axios({
          method: 'get',
          url: `${that.$domain}/item_sales`,
          params: params
        })
        .then((response) => {
          that[attribute] = response.data
          this.iScrollUpdate()
        })
        .catch((error) => {
          that[attribute] = null
          console.log(error)
        })
      },
      loadSalesHistoryAll () {
        // Load current and then previous sales history
        return this.loadSalesHistory()
        .then(this.loadSalesHistory('salesHistoryPrevious', this.updatePreviousDateRange()))
      },
      loadSalesForecastHistory () {
        // Load the last 12 months of sales
        let dateRange = moment.range(moment().subtract(13, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month'))
        return this.loadSalesHistory('salesForecastHistory', dateRange, 'month')
      },
      loadSalesInventory () {
        let that = this
        let params = that.applyParams({}, true)

        that.salesInventory = null

        return axios({
          method: 'get',
          url: `${that.$domain}/products/inventory`,
          params: params
        })
        .then((response) => {
          that.salesInventory = response.data.inventories
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadSalesMethods () {
        this.loadSalesAffinity()
        this.loadSales()

        return axios.all([
          this.loadDashboards(),
          this.loadSalesInventory()
        ])
        .then(() => {
          this.loadCustomerTopResultsAll()
          this.loadVariantTopResults()
          this.loadDashboardsAll()
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadTrafficAnalytics (endpoint, attribute) {
        let that = this
        let params = that.applyParams({}, true)

        that[attribute] = null

        return axios({
          method: 'get',
          url: `${that.$domain}/google_analytics/${endpoint}`,
          params: params
        })
        .then((response) => {
          that[attribute] = response.data
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadTrafficVisitors (includeProductId = true, endpoint = 'page_traffic') {
        let that = this
        let params = that.applyParams({}, true, includeProductId)

        return axios({
          method: 'get',
          url: `${that.$domain}/google_analytics/${endpoint}`,
          params: params
        })
      },
      loadTrafficVisitorsAll () {
        let that = this

        that.trafficVisitors = null
        that.trafficVisitorsAll = null

        return axios.all([
          this.loadTrafficVisitors(true),
          this.loadTrafficVisitors(false, 'traffic')
        ])
        .then(axios.spread((trafficVisitors, trafficVisitorsAll) => {
          that.trafficVisitors = trafficVisitors.data
          that.trafficVisitorsAll = trafficVisitorsAll.data

          this.loadTrafficAnalytics('page_devices', 'trafficDevices')
          this.loadTrafficAnalytics('page_sources', 'trafficSources')
          this.loadTrafficAnalytics('page_locations', 'trafficLocation')
          this.loadTrafficAnalytics('page_browsers', 'trafficBrowser')
          this.loadTrafficAnalytics('page_locations', 'trafficMap')
          this.iScrollUpdate()
        }))
        .catch((error) => {
          console.log(error)
        })
      },
      loadVariantIds () {
        this.variantIds = []
        if (this.filtersActive.length > 0) {
          // Filter to variants with active filters
          let variants = _filter(this.product.variants, (o) => {
            // extract "id" value from each object in filtersActive
            // and create a new array from the ids
            let filterIds = _map(this.filtersActive, 'id')

            // return
            return _intersection(o.filter_list, filterIds).length > 0
          })
          this.variantIds = _map(variants, 'id')
        }
      },
      loadVariantTopResults () {
        let that = this
        let params = that.applyParams({
          group_by: 'variant_id',
          limit: 0
        }, true)

        that.variantTopResults = null

        return axios({
          method: 'get',
          url: `${that.$domain}/top_results`,
          params: params
        })
        .then((response) => {
          that.variantTopResults = response.data.top_results
          this.iScrollUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      numCollectionsMsg (numCollections) {
        let msg = `${numCollections} Collection`

        if (numCollections === 1) {
          return msg
        }

        return `${msg}s`
      },
      removeProduct () {
        let contentNavTab = document.querySelector('.tab-content__item.active')
        let navTab = document.querySelector('.tab-nav__item.active')

        this.toggleClass('product-detail-active', 'product-detail-transition', 500)

        setTimeout(() => {
          clearInterval(this.interval)
          this.activeUsers = 0
          this.product = null
          this.iScrollDestroy()
          if (contentNavTab) {
            contentNavTab.classList.remove('active')
          }
          if (navTab) {
            navTab.classList.remove('active')
          }
        }, 500)
      },
      updatePreviousDateRange () {
        // Determine previous period range based on current date range
        let days = this.$parent.filterDateRange.diff('days')
        let end = moment(this.$parent.filterDateRange.start).subtract(1, 'days').endOf('day')
        this.previousDateRange = moment.range(
          moment(end).subtract(days, 'days').startOf('day'),
          end
        )
        return this.previousDateRange
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/pages/ProductDetail.vue